import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for input base style.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiInputBaseStyle = (theme: Theme): ThemeStyle => {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      background: theme.palette.common.white,
    },
    input: {
      fontSize: 14,
      lineHeight: '16px',
      color: theme.palette.text.primary,
      borderRadius: theme.shape.borderRadius,
      padding: 12,
      height: 'auto',

      '&$disabled': {
        opacity: 0.5,
      },
    },

    inputMultiline: {
      lineHeight: '18px',
    },
  };
};
